// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SensitiveDataIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M16.11 9.1V6.04a4 4 0 1 0-8 0V9.1a7.11 7.11 0 1 0 8 0m-6.5-3.07a2.5 2.5 0 0 1 5 0v2.3a7 7 0 0 0-5 0zm2.5 14.6a5.61 5.61 0 1 1 3.95-1.66 5.6 5.6 0 0 1-3.95 1.63z"
    />
    <path
      fill="currentColor"
      d="M12.1 12.03a2 2 0 0 0-.74 3.85v1.4a.75.75 0 1 0 1.5 0v-1.4a2 2 0 0 0-.75-3.85"
    />
  </svg>,
  "SensitiveData",
);
export default SensitiveDataIcon;
